(function () {
    'use strict';

    angular
        .module('emails')
        .controller('deleteAudienceController', deleteAudienceController);

    deleteAudienceController.$inject = ['$uibModalInstance', 'audience', 'AudienceService', 'toastr', 'audienceList'];

    function deleteAudienceController($uibModalInstance, audience, AudienceService, toastr, audienceList) {
        var vm = this;
        vm.audience = audience;
        vm.audienceList = audienceList;
        vm.ok = ok;
        vm.cancel = cancel;

        activate();

        function activate() {
        }

        function ok () {
            vm.query = [];
            vm.query['id'] = audience.id;
            AudienceService.deleteAudience(vm.query).then(function(response) {
                if(response.data.status_code !== 200) {
                    toastr.error(response.data.msg);
                } else {
                    toastr.success(response.data.msg);
                    vm.audienceList.splice(vm.audienceList.indexOf(audience), 1);
                    if(vm.audienceList.length==0){
                        vm.flag = false;
                    }
                }
                $uibModalInstance.close();
            }).catch(function(err) {
                toastr.error('Error:'+err);
            });
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();